'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _RecipientsList = require('components/Recipients/RecipientsList/RecipientsList');

var _RecipientsList2 = _interopRequireDefault(_RecipientsList);

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var StatisticsRecipientsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activeOrder: state.statistics.recipientsActiveOrder,
    order: state.statistics.recipientsOrder
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsRecipientsList, _Component);

  function StatisticsRecipientsList() {
    (0, _classCallCheck3.default)(this, StatisticsRecipientsList);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipientsList.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipientsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsRecipientsList, [{
    key: 'setStatisticsRecipient',
    value: function setStatisticsRecipient(recipient) {
      this.context.push('/statistics/recipient/' + recipient.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipientsLoading = _props.recipientsLoading,
          recipients = _props.recipients,
          activeOrder = _props.activeOrder,
          order = _props.order,
          recipientsReorder = _props.recipientsReorder;


      return _react2.default.createElement(_RecipientsList2.default, {
        className: className,
        activeOrder: activeOrder,
        order: order,
        onReorder: recipientsReorder,
        recipients: recipients,
        onClick: this.setStatisticsRecipient,
        loading: recipientsLoading
      });
    }
  }]);
  return StatisticsRecipientsList;
}(_react.Component), _class3.propTypes = {
  activeOrder: _propTypes2.default.string,
  className: _propTypes2.default.string,
  order: _propTypes2.default.object,
  recipients: _propTypes2.default.array.isRequired,
  recipientsLoading: _propTypes2.default.bool,
  recipientsReorder: _propTypes2.default.func
}, _class3.contextTypes = {
  push: _propTypes2.default.func
}, _class3.defaultProps = {
  recipients: [],
  recipientsLoading: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setStatisticsRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setStatisticsRecipient'), _class2.prototype)), _class2)) || _class);
exports.default = StatisticsRecipientsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsRecipientsList/StatisticsRecipientsList.js
// module id = 2224
// module chunks = 1